import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {UserpermissionService} from '../../services/userpermission.service';
import{ArticleService} from '../../services/article.service';
import {UserService} from '../../services/user.service';
declare var $:any;//Required for jquery use

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {

 @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue

 userName='';
 navigationsType=[];
 notification:any=[];
 msg:any;
 toastr:any;
 _router:any;
 token:any='';

 constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService,private userService:UserService,private userpermissionService:UserpermissionService) { 
  this.msg = msg;
  this.toastr = toastr;
  this._router =_router; 

  }

  ngOnInit() {
    
    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        // limit:10,
        // 'page':'settings'
      }
      
      this.groupList(data);

     
    }catch(error){

      this._router.navigate(['/vlogin']);

    }
  }

  groupList(data){

    this.articleService.getUserGroup(data).subscribe( (res)=>{

      if(res.status=='success'){
       
        this.userName=res.user.name;

        this.navigationsType=res.navigation;

        this.notification =res.notification;

        this.broadcast_menu();
       
      }else{        
        this.toastr.error(res.message, '', {timeOut: 5000});
      }
    });

  }

  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   } 

}
